import React from "react"
import {Route, Switch} from "react-router-dom"
import * as Util from "../common"
import RankingsList from "./RankingsList"
import Rankings from "./Rankings"

export default props => {
  const {match} = props
  return (
    <Switch>
      <Route exact path={match.path} component={RankingsList} />
      <Route path={match.path + "/:league/:rankName"} component={Rankings} />
      <Route
        path={match.path + "/:league/:rankName/:page"}
        component={Rankings}
      />
      <Route component={Util.NotFoundView} />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/rankings/RankingsRouter.js